import Vue from 'vue'
import { SET_INFO, SET_STATE, SET_MARGIN_CALCULATOR_LIST,
  SET_TOGGLE_LOADER} from '../types'

export const mutations = {
  // broadcast app message
  [SET_INFO] (state, data) {
    state.message = typeof data !== 'undefined' ? data : {
			info: '',
			msg: '',
			errors: []
		}
  },
  
  [SET_STATE] (state, data) {
    try {
		const usr = data
		state.user = usr
    }catch (ex) {
		console.debug('set state EX', ex)
    }
   },

   //SET_MARGIN_CALCULATOR_LIST
    [SET_MARGIN_CALCULATOR_LIST] (state, data) {
        try {
            const mrg = data
            state.marginCalculatorObj = mrg
        }catch (ex) {
            console.debug('set state EX', ex)
        }
    },

   

 
  [SET_TOGGLE_LOADER] (state, ids) {
    try {
      const loaders = state.loaders
      for (let elem in loaders) {
        state.loaders[elem] = (ids.length<1) ? false : !loaders[elem]
      }
    } catch (ex) {
      console.log('set toggle loader EX', ex)
    }
   }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js